import { IS_DEVELOPMENT } from '../../config';

export const log = <T>(message?: T) => IS_DEVELOPMENT && console.log(message);
